const GoogleMaps = () => (
  <div className="grid gap-8 md:grid-cols-2" data-testid="location-maps">
    <div>
      <h3 className="dv-size-subheading text-xl font-bold mb-4 text-gray-900">Delta Valley Health Club — Brentwood</h3>
      <div className="aspect-video w-full">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3145.8969899999997!2d-121.6959!3d37.9318!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808ffe8481b38543%3A0xe07edebad57d3bce!2sDelta%20Valley%20Health%20Club!5e0!3m2!1sen!2sus!4v1234567890"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Delta Valley Health Club - Brentwood"
        />
      </div>
      <p className="dv-size-body mt-3 text-gray-600">120 Guthrie Ln., Brentwood, CA 94513</p>
    </div>

    <div>
      <h3 className="dv-size-subheading text-xl font-bold mb-4 text-gray-900">Delta Valley Health Club — Discovery Bay</h3>
      <div className="aspect-video w-full">
        <iframe
          src="https://www.google.com/maps?q=1520%20Discovery%20Bay%20Blvd%2C%20Discovery%20Bay%2C%20CA%2094505&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Delta Valley Health Club - Discovery Bay"
        />
      </div>
      <p className="dv-size-body mt-3 text-gray-600">1520 Discovery Bay Blvd, Discovery Bay, CA 94505</p>
    </div>
  </div>
);

export default GoogleMaps;
